import { useEffect, useState } from "react";
import UserManagementActions from "../../../../Actions/UserManagementActions";
import { useLanguageContext } from "../../../../Context/LanguageContext";
import commonUtils from "../../../../helpers/commonUtils";
import { useGlobalSpinnerActionsContext } from "../../../../Context/GlobalSpinnerContext";
import ConfirmationPopUp from "../../../MessageBox/ConfirmationPopUp";
import costCenterGroupStore from "../../../../Stores/CostCenterGroupStores";
import CostCenterGroupConstants from "../../../../Constants/CostCenterGroupConstants";
import AppConstants from "../../../../Constants/AppConstants";

const AddCostCenter = (props) => {
  const { costCenterDetails, plantList, selectedPlantId, onClosePopOVer } =
    props;
  const [costCenterID, setCostCenterID] = useState(AppConstants.DEFAULT_GUID);
  const [addCostCenter, setAddCostCenter] = useState("");
  const [costCenterGroup, setCostCenterGroup] = useState("");

  const [plantId, setPlantId] = useState(
    selectedPlantId ? selectedPlantId : "",
  );
  const [display_plantId, setDisplayPlantId] = useState("");
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [costCenterGrpList, setCostCenterGrpList] = useState([]);
  useEffect(() => {
    setCostCenterID(
      costCenterDetails.id ? costCenterDetails.id : AppConstants.DEFAULT_GUID,
    );
    setAddCostCenter(costCenterDetails.kost ? costCenterDetails.kost : "");
    setCostCenterGroup(
      costCenterDetails.kostGroupID ? costCenterDetails.kostGroupID : "",
    );
    setPlantId(selectedPlantId ? selectedPlantId : "");
    costCenterDetails
      ? commonUtils.setIsEdit(true)
      : commonUtils.setIsEdit(false);
  }, [props]);

  const costCenterAdd = (e) => {
    e.preventDefault();
    const isPlantSame =
      addCostCenter.trim().split("-")[0].toLowerCase() ===
      display_plantId.trim().toLowerCase();
    if (isPlantSame) {
      addorUpdateCostCenter();
    } else {
      alertUser();
    }
  };

  const addorUpdateCostCenter = () => {
    setGlobalSpinner(true);

    const kost = {
      ID: costCenterID,
      Kost: addCostCenter.trim(),
      WerkID: plantId,
      KostGroupID: costCenterGroup,
    };
    UserManagementActions.addOrUpdateCostCentreByPlantId(kost);
  };
  const handlePopOverClose = () => {
    if (!costCenterDetails) {
      setPlantId(plantList[0].id);
      setAddCostCenter("");
      setCostCenterGroup("");
      onClosePopOVer();
    }
  };

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "Alert_User_Different_Plant":
          addorUpdateCostCenter();
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  useEffect(() => {
    function geCostCenterGroupSuccess() {
      const res = costCenterGroupStore.getResult();
      if (res.length > 0) {
        setCostCenterGrpList(res);
      }
    }
    function geCostCenterGroupFailure() {
      const res = costCenterGroupStore.getResult();
    }
    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_SUCCESS,
      geCostCenterGroupSuccess,
    );
    costCenterGroupStore.addChangeListener(
      CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_FAILURE,
      geCostCenterGroupFailure,
    );
    return () => {
      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_SUCCESS,
        geCostCenterGroupSuccess,
      );
      costCenterGroupStore.removeChangeListener(
        CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_FAILURE,
        geCostCenterGroupFailure,
      );
    };
  }, []);
  function alertUser() {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.alertMsg);
    setCallbackData({
      costCenterID: "1",
    });
    setEventType("Alert_User_Different_Plant");
  }

  useEffect(() => {
    if (plantId != "") {
      let selectedPlantData = plantList.filter((item, index) => {
        return item.id == plantId;
      });
      if (selectedPlantData && selectedPlantData.length > 0) {
        setDisplayPlantId(selectedPlantData[0].plantID);
      }
    }

    return () => {};
  }, [plantId]);

  return (
    <div
      className="modal fade"
      id="addCostCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addCostCenter"
      aria-hidden="true"
      data-backdrop="static"
    >
      {" "}
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addCostCenter">
              {costCenterDetails
                ? localization.editCostCenter
                : localization.addCostCenter}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addCostCenterModalClose"
              onClick={handlePopOverClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="costCenterAdd" autoComplete="off" onSubmit={costCenterAdd}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="plantList">{localization.plant}</label>
                <select
                  className="form-control"
                  id="plantList"
                  name="plantList"
                  required
                  value={plantId}
                  onChange={(e) => {
                    setPlantId(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    {localization.selectPlant}
                  </option>
                  {plantList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {`${row.bezeichnung} (${row.plantID})`}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="costCenter">
                  {localization.costCenterName}
                  <span className="ml-1 font-weight-bold cstFntSiz">{`(${localization.lableCostCenterName}${display_plantId}-${localization.name})`}</span>
                </label>
                <input
                  type="text"
                  id="costCenter"
                  name="costCenter"
                  className="form-control"
                  required
                  placeholder={localization.costCenterName}
                  value={addCostCenter}
                  onChange={(e) => {
                    e.preventDefault();
                    if (addCostCenter !== "") {
                      setAddCostCenter(e.target.value);
                    } else {
                      setAddCostCenter(e.target.value.trim());
                    }
                  }}
                />
              </div>

              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="costCenterGroup">
                  {localization.costCenterGroup}
                </label>
                <select
                  className="form-control"
                  id="costCenterGroup"
                  name="costCenterGroup"
                  required
                  value={costCenterGroup}
                  onChange={(e) => {
                    setCostCenterGroup(e.target.value);
                  }}
                >
                  <option value={""}>{"select "}</option>
                  {costCenterGrpList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.costGroup}
                      </option>
                    );
                  })}
                </select>

                <span>{localization.noteCostCentergrp}</span>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </div>
  );
};

export default AddCostCenter;
